/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

export enum V6Route {
  MaterialityAssessmentRoot = 'materialityAssessment_root',
  MaterialityAssessmentTestingTool = 'materialityAssessment_testing_tool',
  MaterialityAssessmentInitiative = 'materialityAssessment_initiative',
  MaterialityAssessmentSurveysList = 'materialityAssessment_surveys_list',
  MaterialityAssessmentSurvey = 'materialityAssessment_survey',
  MaterialityAssessmentSurveyQuestion = 'materialityAssessment_survey_question',
  MaterialityAssessmentSurveyQuestionIndex = 'materialityAssessment_survey_question_index',
};

export interface V6RouteDefinition {
  id: V6Route;
  path: string;
  children?: V6RouteDefinition[];
}
